import React from 'react';
import PropTypes from 'prop-types';

import { BLACK, PORCELAIN, SILVER_SAND } from '@constant/colors';

const MailClientSmall = ({ className }) => (
  <svg className={className} viewBox="0 0 251 187">
    <defs>
      <path
        d="M0 3.992C0 1.7873 1.787 0 4.0014 0h237.9972C244.2086 0 246 1.7866 246 3.992V182H0V3.992z"
        id="mailclient-small-a"
      />
      <filter
        x="-1%"
        y="-1.4%"
        width="103.3%"
        height="104.4%"
        filterUnits="objectBoundingBox"
        id="mailclient-small-b"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset
          dx="3"
          dy="3"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        />
        <feComposite
          in="shadowOffsetOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowOffsetOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1146 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)">
        <use
          fill={BLACK}
          filter="url(#mailclient-small-b)"
          xlinkHref="#mailclient-small-a"
        />
        <use fill={PORCELAIN} xlinkHref="#mailclient-small-a" />
        <path
          strokeOpacity=".0751"
          stroke={BLACK}
          d="M-.5 3.992C-.5 1.5094 1.5125-.5 4.0014-.5h237.9972c2.486 0 4.5014 2.0104 4.5014 4.492V182.5H-.5V3.992z"
        />
      </g>
      <path
        d="M11.1333 10C9.9551 10 9 9.1046 9 8s.9551-2 2.1333-2c1.1782 0 2.1334.8954 2.1334 2s-.9552 2-2.1334 2zM17 10c-1.1782 0-2.1333-.8954-2.1333-2S15.8217 6 17 6c1.1782 0 2.1333.8954 2.1333 2s-.955 2-2.1333 2zm5.8667 0c-1.1782 0-2.1334-.8954-2.1334-2s.9552-2 2.1334-2S25 6.8954 25 8s-.9551 2-2.1333 2z"
        fill={SILVER_SAND}
      />
    </g>
  </svg>
);

MailClientSmall.propTypes = {
  className: PropTypes.string,
};

export default MailClientSmall;
